<!--MobileBanner:移动端通用banner 2021/12/20 17:30:06 YuAng-->

<template>
  <div class="ho-mobile-banner" :class="item.name">
    <p class="title">{{item.title}}</p>
    <p v-if="item.subtTitle" class="sub-title">{{item.subtTitle}}</p>
    <p class="desc">{{item.desc}}</p>
    <p class="btns">
      <span class="first" @click="lookVideo(item)"><i class="el-icon-caret-right"></i>视频介绍</span>
      <span @click="jumpNext()">立即试用</span>
    </p>
    <p class="pics">
      <img alt="宣传图" width="165px" :src="require('../../../../assets/images/mobile/' + item.name + '_banner_intro.png')" />
    </p>
    <!-- 视频蒙层 -->
    <popup-video :video="video"></popup-video>
  </div>
</template>
<script>
import PopupVideo from './PopupVideo.vue'
export default {
  components: { PopupVideo },
  name: 'MobileBanner',
  props: {
    item: {
      type: Object,
      default: function () {
        return {
          name: 'home',
          title: '省时省力  因为懂你',
          subtTitle: '好内容+好平台 更懂您的智慧教学',
          desc: '学科网e课堂基于学科网精品内容资源优势，融合大数据、AI等技术打造而成，助力教师精准教学，区域、学校智慧化管理，家校共育，构建三位一体的智慧教学模式',
        }
      }
    }
  },
  data() {
    return {
      video: {
        visible: false,
        url: '',
        title: null
      }
    }
  },
  methods: {
    lookVideo: function (item) {
      this.video.url = item.url
      this.video.title = item.subtTitle ? item.subtTitle : item.title
      this.video.visible = true
    },
    jumpNext: function () {
      window.open('/official/eclass/mobile/apply', '_blank')
    }
  }
}
</script>

<style scoped>
.ho-mobile-banner {
  background-color: dodgerblue;
  background-image: url(../../../../assets/images/mobile/banner_bg.png);
  background-repeat: no-repeat;
  color: white;
  text-align: center;
  overflow: hidden;
  padding: 56px 32px 0 32px;
  background-repeat: no-repeat;
  height: 406px;
  background-size: 100% 406px;
}

.ho-mobile-banner p {
  margin-bottom: 16px;
}

.logo {
  text-align: left;
}

.title {
  font-size: 18px;
}

.desc {
  font-size: 12px;
}

.btns span {
  display: inline-block;
  height: 27px;
  min-width: 100px;
  line-height: 26px;
  border: 1px solid white;
  border-radius: 13px;
  background: white;
  color: #588bf6;
  font-size: 12px;
  position: relative;
}

span.first {
  background: transparent;
  color: white;
  margin-right: 16px;
}

span .el-icon-caret-right {
  position: absolute;
  left: 2px;
  top: 3px;
  font-size: 19px;
  background-color: white;
  color: dodgerblue;
  border-radius: 50%;
}
</style>